function toggleNav() {
    let menuButton = document.querySelector('.hamburger'),
        menuNavigation = document.querySelector('.navigation-mobile');

    if (menuNavigation.classList.contains('show')) {

        menuNavigation.classList.remove('show');
        menuButton.classList.remove('hamburger--close');
        document.body.classList.remove('no-overflow');

    } else {

        menuNavigation.classList.add('show');
        menuButton.classList.add('hamburger--close');
        document.body.classList.add('no-overflow');

    }
}

let inMenuState = false,
    inMenuTimeout = null;

function init() {
    const mobileNavigation = document.querySelector('.navigation-mobile');
    const desktopNavigation = document.querySelector('.navigation-main');

    const menuButton = document.querySelector('.hamburger');
    if (menuButton) {
        menuButton.addEventListener('click', () => {
            toggleNav();
        });
    }

    const submenuNavigation = mobileNavigation.querySelectorAll('.has-sub-menu');
    if (submenuNavigation) {
        submenuNavigation.forEach(navElement => {
            let elementLabel = navElement.querySelector('.navigation-menu__element__label');
            if (elementLabel) {
                elementLabel.addEventListener('click', () => {
                    navElement.classList.toggle('active');
                });
            }
        });
    }

    const animationDelay = 400,
        flyMenu = document.querySelector('.navigation-flyout'),
        flyMenuInner = document.querySelector('.navigation-flyout__inner');
    if (flyMenu) {
        flyMenuInner.onmouseleave = () => {
            const isRelated = event.relatedTarget.parentNode.classList.contains('navigation-menu__element');
            if (!isRelated) {
                hideFlyerMenu();
            }
        };
    }

    function hideFlyerMenu() {
        inMenuState = false;
        flyMenu.classList.add('navigation-flyout--hidden');
        document.body.classList.remove('no-overflow');
        flyMenuInner.innerHTML = '';
        flyMenuInner.style.height = 'auto';
        menuElements.forEach(navElement => {
            navElement.classList.remove('active');
        });
        clearTimeout(inMenuTimeout);
    }

    const menuElements = desktopNavigation.querySelectorAll('.navigation-menu__element');
    if (menuElements) {
        menuElements.forEach(navElement => {
            const menuDropdown = navElement.querySelector('.navigation-menu__dropdown');
            navElement.onmouseleave = () => {
                navElement.classList.remove('active');
            };
            navElement.onmouseenter = () => {
                if (inMenuTimeout) {
                    clearTimeout(inMenuTimeout);
                }
                inMenuState = true;
                navElement.classList.add('active');

                setTimeout(() => {
                    if ($(navElement).hasClass('hide-menu')) {
                        hideFlyerMenu();
                    }
                    if ($(navElement).hasClass('active')) {
                        flyMenuInner.innerHTML = menuDropdown.innerHTML;
                        flyMenu.classList.remove('navigation-flyout--hidden');
                        const firstSubmenu = flyMenuInner.querySelector('.navigation-submenu');
                        let firstSubMenuHeight = firstSubmenu.clientHeight,
                            staticPadding = 40;
                        if ((flyMenuInner.clientHeight - staticPadding) < firstSubMenuHeight) {
                            flyMenuInner.style.height = (staticPadding + firstSubMenuHeight) + 'px';
                        } else {
                            flyMenuInner.style.height = 'auto';
                        }
                        const subMenuElements = flyMenuInner.querySelectorAll('.has-sub-menu');
                        if (subMenuElements) {
                            subMenuElements.forEach(subMenuItem => {
                                subMenuItem.onmouseenter = () => {
                                    let subMenuHeight = subMenuItem.querySelector('.navigation-last').clientHeight;
                                    if ((flyMenuInner.clientHeight - staticPadding) < subMenuHeight) {
                                        flyMenuInner.style.height = (staticPadding + subMenuHeight) + 'px';
                                    }
                                };
                            });
                        }
                    }
                }, 200);
            };
        });
    }

    const header = document.querySelector('.header');
    if (header) {
        header.onmouseenter = () => hideFlyerMenu();
    }

    let lastPageY = 0;
    window.addEventListener("scroll", () => {
        if (!inMenuState) {
            let pageY = window.pageYOffset;

            if (pageY > lastPageY) {
                desktopNavigation.classList.add('collapsed');
            } else {
                desktopNavigation.classList.remove('collapsed');
            }

            lastPageY = pageY;
        }
    });

}

export default {init};



// WEBPACK FOOTER //
// ./src/scripts/navigation.js